import { render, staticRenderFns } from "./emptyState.component.vue?vue&type=template&id=13fbaf63&scoped=true&"
import script from "./emptyState.component.vue?vue&type=script&lang=js&"
export * from "./emptyState.component.vue?vue&type=script&lang=js&"
import style0 from "./emptyState.component.vue?vue&type=style&index=0&id=13fbaf63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fbaf63",
  null
  
)

export default component.exports